import { useEffect, useRef, useState } from 'react'
import { useFloorplansContext } from './floorplans-context.jsx'
import NorthArrow from '../../../svg/north-arrow.svg'

export default function PlanView() {
  const plans = floorplanData?.plans || []
  const { activePlan } = useFloorplansContext()
  const activePlanData = plans.find((p) => p.plan_id === activePlan)
  const [renderedPlan, setRenderedPlan] = useState(activePlanData || null)
  const [isClosing, setIsClosing] = useState(false)
  const planViewRef = useRef(null)
  const brochurePdf = floorplanData?.brochure_pdf || ''
  const floorplanDisclaimerText = floorplanData?.floorplan_disclaimer_text || ''

  useEffect(() => {
    if (activePlanData) {
      setRenderedPlan(activePlanData)
      setIsClosing(false)
      return
    }

    if (renderedPlan) {
      setIsClosing(true)
    }
  }, [activePlanData, renderedPlan])

  const handleTransitionEnd = (event) => {
    if (event.target !== planViewRef.current || event.propertyName !== 'width') {
      return
    }

    if (!activePlan && isClosing) {
      setRenderedPlan(null)
      setIsClosing(false)
    }
  }

  return (
    <div className="plan-view d-none d-md-flex" ref={planViewRef} onTransitionEnd={handleTransitionEnd}>
      {renderedPlan && (
        <div className="plan-view-inner">
          <div className="name-buttons">
            <h2>{renderedPlan.plan_name}</h2>
            <div className="buttons">
              <a href={renderedPlan.plan_pdf} className="btn btn-primary" target="_blank" rel="noopener noreferrer">Download Plan</a>
              <a href={brochurePdf} className="btn btn-primary" target="_blank" rel="noopener noreferrer">Download Brochure</a>
            </div>
          </div>
          {renderedPlan.plan_image && 
            <div className="plan-image">
              <img src={renderedPlan.plan_image} alt={renderedPlan.plan_name} />
            </div>
          }
          {renderedPlan.key_plates && 
            <div className="plan-keyplate">
              <img src={renderedPlan.key_plates} alt={`${renderedPlan.plan_name} Key Plates`} />
              <div className="north-arrow">
                <NorthArrow />
              </div>
            </div>
          }
          {floorplanDisclaimerText && (
            <div className="floorplan-disclaimer-text fine-print">
              {floorplanDisclaimerText}
            </div>
          )}
        </div>
      )}
    </div>
  )
}